import { Button } from '@uhg-abyss/web/ui/Button';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { useTranslation } from 'react-i18next';

import { StyledFooterAlignRight } from '../../../common/ConstantsStyles';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  signInUrl: string;
  uhcContinueUrl: string;
};

export const GuestPlanRequiredModal = ({
  isOpen,
  onClose,
  signInUrl,
  uhcContinueUrl,
}: Props) => {
  const { t } = useTranslation();

  const headerText = t('GUEST_PRE_PLAN_SELECTION.TITLE', {
    defaultValue: 'Continue as Guest or Sign In?',
  });

  const bodyText = t('GUEST_PRE_PLAN_SELECTION.CONTENT', {
    defaultValue:
      "You're now leaving the Guest experience. Sign in for a more personalized experience or continue to uhc.com.",
  });

  return (
    <ModalDialog
      className="guest-plan-required-modal"
      closeOnClickOutside={false}
      css={{
        'abyss-modal-base-header-container': {
          padding: '16px',
        },
      }}
      data-auto-testid="guest-plan-required-modal"
      data-testid="guest-plan-required-modal"
      footer={
        <StyledFooterAlignRight>
          <Layout.Group style={{ gap: 8 }}>
            <Button
              data-testid="guest-plan-required-sign-in"
              onClick={() => window.location.assign(signInUrl)}
            >
              {t('GUEST_PRE_PLAN_SELECTION.SIGN_IN')}
            </Button>
            <Button
              data-testid="guest-plan-required-continue"
              onClick={() => window.location.assign(uhcContinueUrl)}
              variant="outline"
            >
              {t('GUEST_PRE_PLAN_SELECTION.CONTINUE')}
            </Button>
          </Layout.Group>
        </StyledFooterAlignRight>
      }
      header={headerText}
      isOpen={isOpen}
      onClose={onClose}
    >
      {bodyText}
    </ModalDialog>
  );
};

export default GuestPlanRequiredModal;
